import React from 'react';
import { useTheme } from '@tanium/react-theme-context';
import { GridBase, GridBaseProps } from './GridBase';
import { GridGap, GridGapConfig } from './layout-helpers';

export type GridProps = GridBaseProps;

export function Grid({ gap, ...rest }: GridProps) {
  const { space } = useTheme();

  const adjustGapIfNecessary = (gapToAdjust: GridGap | undefined) =>
    typeof gapToAdjust === 'number' ? gapToAdjust * space.multiple : gapToAdjust;

  const adjustedGap: GridGapConfig | undefined = Array.isArray(gap)
    ? (gap.map((_) => adjustGapIfNecessary(_)) as [GridGap, GridGap])
    : adjustGapIfNecessary(gap);

  return <GridBase gap={adjustedGap} {...rest} />;
}
